<template>
  <div>
    <!-- 操作栏 -->
    <div style="margin:20px 0 ;">
      <el-radio-group v-model="clickMenubarName" @change="clickEvent" size="mini" style="margin-right: 0px;">
        <el-radio border v-for="item in menubarFun" :key="item.id" :title="item.name" :label='item.name'
         style="margin-right:4px;">
          {{item.title}}
        </el-radio>
      </el-radio-group>
      边框颜色：
      <el-color-picker class="select-color" v-model="borderColor" @change="borderColorChange"
        size="small" style="margin-right: 10px;"></el-color-picker>
      <span style="margin-right: 10px;">
        线条宽度：
        <el-input-number v-model="borderWidth" controls-position="right" @change="borderWidthChange" :min="1" :max="5"  size="mini"></el-input-number>
      </span>
      <span>
        <el-button @click="resetCanvas" size="small" style="margin-left: 10px;">重置画布</el-button>
        <el-button @click="saveFile" type="primary" plain size="small">保存上传</el-button>
      </span>

    </div>
    <!-- 画布元素 -->
    <canvas width="1000" height="300" id="canvas-box"></canvas>
    <span class="tip">tip：定义画布内容后，请点击右上角保存上传</span>
    <el-radio-group v-model="selectedText" @change="onTextChange" style="margin:30px 6%;">
      <el-radio-button label="Na">Na=无附件</el-radio-button>
      <el-radio-button label="EXP">EXP=扩弓</el-radio-button>
      <el-radio-button label="EX">EX=拔牙</el-radio-button>
      <el-radio-button label="M">M=缺失牙</el-radio-button>
      <el-radio-button label="NM">NM=不可移动牙齿</el-radio-button>
      <el-radio-button label="DM">DM=远移磨牙</el-radio-button>
      <el-radio-button label="IRP">IRP=可邻面去釉牙齿</el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
import { fabric } from 'fabric';
import {
  uploadByPieces
} from "../../common/upload.js";
export default {
  data() {
    return {
      canvas: '',
      menubarFun: [
        {
          id: 1,
          name: 'select',
          title: '选择', //提示
        },
        {
          id: 2,
          name: 'drawing',
          title: '自由绘画',
        },
        {
          id: 4,
          name: 'rect',
          title: '矩形',
        },
        {
          id: 5,
          name: 'ellipse',
          title: '椭圆形',
        },
        {
          id: 6,
          name: 'text',
          title: '文本',
        }
      ],
      canvasUrl:'',//上传云存储的url
      clickMenubarName: 'select', //当前点击的name
      downPoint: {}, //鼠标按下的点位置
      borderWidth: 1, //所有图形边框的宽度
      borderColor: '#409EFF', //所有图形边框的颜色
      backStack: [], //所有的绘画对象栈
      patternClass: null, //鼠标按下绘制的对象
      imageUrl: '../../static/tooth.jpg',
      textObj:'',
      selectedText:'',
      flagUp: '',//处理事件逻辑状态
    }
  },
  props:{
    isCreate:{
      type:Boolean,
      default:false
    },
    correctiveImg:{
      type:Array,
      default:''
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy(){
    document.removeEventListener('keyup',this.keyBoard)
  },
  methods: {
    init() {
      this.canvas = new fabric.Canvas('canvas-box');
      // let canvasBackImg = '';
      // let img = JSON.parse(sessionStorage.getItem('canvasImage'));
      // canvasBackImg = this.imageUrl;

      // if(this.isCreate){
      //   canvasBackImg = img?img[0]:this.imageUrl;
      // }else{
      //   canvasBackImg = this.correctiveImg[0]==undefined?this.imageUrl:this.correctiveImg[0];
      // }
      fabric.Image.fromURL(this.imageUrl, (img) => {
        img.set({
          // 通过scale来设置图片大小，这里设置和画布一样大
          scaleX: this.canvas.width / img.width, // 这里也可以写0 - 1
          scaleY: this.canvas.height / img.height, // 这里也可以写0 - 1
        });
        // 设置背景
        this.canvas.setBackgroundImage(
          img,
          this.canvas.renderAll.bind(this.canvas)
        );
        this.canvas.renderAll();
      });

      this.canvas.on({
        'mouse:down': opt => {
          this.downPoint = opt.absolutePointer;//记录下鼠标按下时的坐标
          // 对文字对象的判断 判断是编辑还是新增
          this.isTextObj(opt)
          this.drawing();//绘制图片
        },
        'mouse:move': opt => {
          this.patternFun(opt)//重绘图形
        },
        //鼠标抬起
        'mouse:up': opt => {
          if (!this.patternClass || this.clickMenubarName == 'text') {
            if (this.clickMenubarName == 'none' && !opt.target) {
              this.seal()
            }
            //将自由绘画的对象存在栈中
            if (!this.patternClass && this.canvas.selection === false) {
              //比较对象长度是否发生变化，是否有新增
              let getObj = this.canvas.getObjects()
              if (this.canvasObjLength !== getObj.length) {
                this.canvasObjLength = getObj.length
              }
            }
            this.backStack.push(this.patternClass)
            this.patternClass = null
            let flag = this.backStack.length>0?true:false;
            this.$emit('ruleFlag',flag)
            return
          }
          
          if (this.clickMenubarName != 'broken') {
            if (JSON.stringify(this.downPoint) === JSON.stringify(opt.absolutePointer)) {
              this.canvas.remove(this.patternClass)
            } else {
              //将当前对象压入栈中
              this.backStack.push(this.patternClass)
            }
            //将创建的对象置空
            this.patternClass = null
          }
        },
        //更换选中对象
        'selection:updated':opt=>{
          this.flagUp = opt;
        },
        // 创建对象
        'selection:created': opt=>{
          this.flagUp = opt;
          this.keyBoard()
        },
      })
    },
    //判断上次的文字对象内容和编辑状态
    isTextObj(opt) {
      if (this.textObj !== '') {
        if (this.textObj.isEditing === true) {
          this.textObj.exitEditing()
          //将文字对象存在栈中
          this.backStack.push(this.textObj)
        }
        if (this.textObj.text === '') {
          this.canvas.remove(this.textObj) //空文本删除
          this.textObj = ''
        }
      }
      //判断当前点击的对象是不是文字
      if (opt.target) {
        this.textObj = opt.target
        console.log('当前点击对象',this.textObj)
      }
    },

    //创建图形
    drawing() {
      switch (this.clickMenubarName) {
        case 'rect':  //绘制矩形
          this.patternClass = new fabric.Rect({
            top: this.downPoint.y, //创建对象的坐标
            left: this.downPoint.x,
            width: 0, //宽和高
            height: 0,
            fill: 'transparent', //填充颜色
            stroke: this.borderColor, //线条颜色
            strokeWidth: 3 //线条宽度
          })
          this.canvas.add(this.patternClass)
          break
        case 'ellipse':   //绘制椭圆形
          this.patternClass = new fabric.Ellipse({
            top: this.downPoint.y,
            left: this.downPoint.x,
            rx: 0, //椭圆的两个中心点
            ry: 0,
            fill: 'transparent',
            stroke: this.borderColor,
            strokeWidth: 3
          })
          this.canvas.add(this.patternClass)
          break
        case 'text':   //绘制文本
          this.patternClass = new fabric.Textbox('', {
            left: this.downPoint.x,
            top: this.downPoint.y,
            fontSize: 20,
            hasBorders: true, //修改的时候，是否显示文字所在区域
            width: 450,
            splitByGrapheme: true, //超过宽度自动换行
            fill: this.borderColor, //字体颜色
          })
          this.canvas.add(this.patternClass)
          this.textObj = this.patternClass
          this.patternClass.enterEditing()
          break
      }
    },
    borderColorChange(){
      this.canvas.freeDrawingBrush.color = this.borderColor; // 设置线条颜色
    },
    borderWidthChange(value) {
      this.borderWidth = parseInt(value)
      this.canvas.freeDrawingBrush.width = this.borderWidth; // 设置线条宽度
    },
    //重新绘制图形
    patternFun(e) {
      if (this.patternClass) {
        switch (this.clickMenubarName) {
          case 'rect':
            let rectW = Math.abs(this.downPoint.x - e.absolutePointer.x)
            let rectH = Math.abs(this.downPoint.y - e.absolutePointer.y)
            // 设置尺寸和所在位置
            this.patternClass.set('width', rectW)
            this.patternClass.set('height', rectH)
            this.patternClass.set('top', Math.min(e.absolutePointer.y, this.downPoint.y))
            this.patternClass.set('left', Math.min(e.absolutePointer.x, this.downPoint.x))
            // 刷新一下画布
            this.canvas.requestRenderAll()
            break
          case 'ellipse':
            let rx = Math.abs(this.downPoint.x - e.absolutePointer.x) / 2
            let ry = Math.abs(this.downPoint.y - e.absolutePointer.y) / 2
            let top = e.absolutePointer.y > this.downPoint.y ? this.downPoint.y : this.downPoint.y - ry * 2
            let left = e.absolutePointer.x > this.downPoint.x ? this.downPoint.x : this.downPoint.x - rx * 2
            // 设置椭圆尺寸和所在位置
            this.patternClass.set('rx', rx)
            this.patternClass.set('ry', ry)
            this.patternClass.set('top', top)
            this.patternClass.set('left', left)
            this.canvas.requestRenderAll()
            break
          }
      }
    },

    //菜单栏按钮点击事件
    clickEvent(value) {
      this.selectedText = ''
      this.clickMenubarName = value
      if (value == 'select') {//选中
        // console.log('join =>1',value)
        this.canvas.selection = true  // 框选
        this.canvas.skipTargetFind = false // 允许选中
        this.canvas.isDrawingMode = false //关闭自由绘画
      } else if (value == 'drawing') {//自由绘画
        // console.log('join =>2',value)
        this.canvas.selection = false  // 移除框选
        this.canvas.skipTargetFind = true  // 不能选中
        this.canvas.isDrawingMode = true //开启自由绘画
        this.canvas.freeDrawingBrush.color = this.borderColor;
      }else if(value == 'text'){//文本
        // console.log('join =>3',value)
        this.canvas.selection = false  // 不框选
        this.canvas.skipTargetFind = true  // 不选中
        this.canvas.isDrawingMode = false  //关闭自由绘画
      }else {//其他
        // console.log('join =>4',value);
        this.canvas.selection = false  // 去除框选
        this.canvas.skipTargetFind = true  // 不允许选中
        this.canvas.isDrawingMode = false  //关闭自由绘画
      }
      //自由绘画、矩形、椭圆、文本
      // console.log('canvas:',this.canvas);
      // console.log('1:',this.canvas.selection);
      // console.log('2:',this.canvas.skipTargetFind);
      // console.log('3:',this.canvas.isDrawingMode);
    },

    // 点击调用添加印章
    seal(){
      this.patternClass = ''
      this.patternClass = new fabric.Textbox(this.selectedText, {
        left: this.downPoint.x,
        top: this.downPoint.y,
        fontSize: 20,
        hasBorders: true, //修改的时候，是否显示文字
        fill: this.borderColor, //字体颜色
      })
      this.canvas.add(this.patternClass)
      this.textObj = this.patternClass
      this.canvas.requestRenderAll()
      this.backStack.push(this.textObj)
    },

    // 切换为印章
    onTextChange(){
      this.clickMenubarName = 'none'
      this.canvas.selection =  true
      this.canvas.skipTargetFind =  false
      this.canvas.isDrawingMode =  false
    },
    // 监听键盘事件
    keyBoard(){
      document.addEventListener('keyup', e => {
        if(this.flagUp&&e.key==='Delete'||e.key=='Backspace'){
          // 判断文字是否在编辑状态
          if(this.flagUp.selected[0].isEditing===true)return
          this.flagUp.selected.forEach(item => {
            this.canvas.remove(item)
          })
          //抛弃当前处于活动状态的Object
          this.canvas.discardActiveObject()
          this.flagUp = false
        }
      })
    },
    resetCanvas() {
      this.canvas.clear();
      // 重新加载背景图像
      fabric.Image.fromURL(this.imageUrl, (img) => {
        img.set({
          scaleX: this.canvas.width / img.width,
          scaleY: this.canvas.height / img.height,
        });
        this.canvas.setBackgroundImage(
          img,
          this.canvas.renderAll.bind(this.canvas)
        );
        this.canvas.renderAll();
      });
      this.backStack = [];
      this.$emit('ruleFlag',false);
    },
    saveFile(){
      const imageUrl = this.canvas.toDataURL('image/png');
      const blob = this.dataURLtoBlob(imageUrl);
      const file = new File([blob],'tooth-drawing.png',{type:'image/png'});
      // const link = document.createElement('a');
      // link.download = 'tooth-drawing.png';
      // link.href = imageUrl;
      // link.click();
      this.uploadFile(file);
    },
    async uploadFile(file) {
      var loading = this.$loading({
        text: '等待上传完成，已上传 0%'
      });
      uploadByPieces({
        file: file, // 文件
        data: {}, // 其他可能需要的数据
        pieceSize: 3, // 分片大小
        concurrent: 3,
        process: res => {
          console.log('分片上传 -> process', res);
          if (res == 100) {
            loading.close();
          }
        },
        success: res => {
          console.log('res',res)
          this.canvasUrl = res.data.url
          this.$emit('canvasImg',this.canvasUrl)
          console.log('分片上传 -> success', res);
        },
        error: e => {
          console.log('分片上传 -> error', e);
        }
      });
    },
    dataURLtoBlob(dataURL) {
      const parts = dataURL.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const byteCharacters = atob(parts[1]);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  }
}
</script>

<style scoped>
.line{
  background: #ccc;
  border-radius: 50%;
  border: 1px solid #ccc;
  display: inline-block;
}
.select-color{
  .el-color-picker__trigger{
    margin-bottom: -10px;
  }
}
/deep/.el-radio {
  margin: 0;
}
#canvas-box{
  position: relative;
}
.tip{
  position: absolute;
  /* bottom: 39%; */
  left: 36%;
  color: #409EFF;
  z-index:10;
}
</style>



// WEBPACK FOOTER //
// canvasTooth.vue?750d2656